<template>
  <div class="fullBox">
    <div class="pc" v-if="mobileFlag">
      <div class="tabBox">
        <div
          class="tab_item"
          @click="clickTab(0)"
          :class="tabIndex == 0 ? 'active' : ''"
        >
          待确认列表
        </div>
        <div
          class="tab_item"
          @click="clickTab(1)"
          :class="tabIndex == 1 ? 'active' : ''"
        >
          全部列表
        </div>
      </div>
      <div class="content">
        <div class="unifiedForm">
          <el-form
            ref="formInline"
            :inline="true"
            :model="formInline"
            class="demo-form-inline"
          >
            <el-form-item prop="state" v-if="tabIndex == 1">
              <div class="label">归还状态</div>
              <el-select
                v-model="formInline.state"
                placeholder="请选择所属地点"
                clearable
              >
                <el-option label="全部" value="0"></el-option>
                <el-option label="已归还" value="2"></el-option>
                <el-option label="未归还" value="1"></el-option>
                <el-option label="异常" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="buId">
              <div class="label">所属地点</div>
              <el-select v-model="formInline.buId" placeholder="请选择所属地点" clearable>
                <el-option
                  v-for="item in selectList"
                  :key="item.id"
                  :label="item.place"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="time">
              <div class="label">借出时间</div>
              <el-date-picker
                v-model="formInline.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="name">
              <div class="label">借伞人</div>
              <el-input
                v-model="formInline.name"
                placeholder="请输入借伞人"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">
                <i class="el-icon-search"></i>
                查询</el-button
              >
              <el-button class="reset" type="primary" @click="onReset">
                <i class="el-icon-refresh-left"></i>
                重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="tableBox">
          <div class="table" v-if="tabIndex == 0">
            <tableOne
              :tableListOne="tableListOne"
              :page="page"
              @changeSubmit="changeSubmit"
            ></tableOne>
          </div>
          <div class="table" v-else>
            <tableTwo :tableListTwo="tableListTwo" :page="page" @changeSubmit="changeSubmit"></tableTwo>
          </div>
        </div>
        <div class="pager">
          <el-pagination
            :current-page="page.page"
            :page-size="page.pageSize"
            :total="total"
            @current-change="currChange"
            layout="total, prev, pager, next"
          />
        </div>
      </div>
    </div>
    <div class="mobile" v-else>
      <div class="mobile_full"><borrowAndReturnMobile /></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tableOne from "./components/borrowAndReturnTableOne.vue";
import tableTwo from "./components/borrowAndReturnTableTwo.vue";
import borrowAndReturnMobile from "./borrowAndReturnMobile.vue";
import apis from "@/apis/borrowingAnUmbrella";
import { redirectRoute } from "@/utils/tools";
export default {
  name: "borrowAndReturn",
  components: {
    tableOne,
    tableTwo,
    borrowAndReturnMobile,
  },
  data() {
    return {
      tabIndex: 0,
      formInline: {
        state: "0",
        time: "",
        buId: "",
        name: "",
      },
      selectList: [],
      page: {
        page: 1,
        pageSize: 10,
      },
      total: 0,
      tableListOne: [],
      tableListTwo: [],
      mobileFlag: false,
    };
  },
  mounted() {
    if (this.tabIndex == 0) {
      this.getListOne();
    } else {
      this.getListTwo();
    }
    this.getSelectList();
    this.redirect();
  },
  methods: {
    //控制状态显示与隐藏
    redirect() {
      const { id } = this.$route.query;
      const flag = redirectRoute();
      if (id && !flag) {
        this.mobileFlag = false;
      } else {
        this.mobileFlag = true;
      }
      console.log(this.mobileFlag, "this.mobileFlag");
    },
    // tab切换
    clickTab(type) {
      this.tabIndex = type;
      this.page.page = 1;
      if (type == 0) {
        this.getListOne();
      } else {
        this.getListTwo();
      }
    },
    changeSubmit() {
      if (this.tabIndex == 0) {
        this.getListOne();
      } else {
        this.getListTwo();
      }
    },
    // 获取列表数据
    getListOne() {
      const params = {
        type: 2,
        name: this.formInline.name,
        buId: this.formInline.buId,
        startTime: this.formInline.time
          ? moment(this.formInline.time[0]).format("YYYY-MM-DD") + ' ' + '00:00:00'
          : "",
        endTime: this.formInline.time
          ? moment(this.formInline.time[1]).format("YYYY-MM-DD") + ' ' + '23:59:59'
          : "",
        page: this.page.page,
        pageSize: this.page.pageSize,
      };
      apis.recordList(params).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          res.data.list.map((item) => {
            item.children = [];
          });
          this.tableListOne = res.data.list;
          this.tableListOne.length > 0 &&
            this.tableListOne.forEach((item) => {
              item.buTime = moment(item.buTime).format("YYYY-MM-DD HH:mm");
            });
        }
      });
    },
    // 获取列表数据
    getListTwo() {
      const params = {
        type: 1,
        name: this.formInline.name,
        buId: this.formInline.buId,
        state: this.formInline.state,
        startTime: this.formInline.time
          ? moment(this.formInline.time[0]).format("YYYY-MM-DD") + ' ' + '00:00:00'
          : "",
        endTime: this.formInline.time
          ? moment(this.formInline.time[1]).format("YYYY-MM-DD") + ' ' + '23:59:59'
          : "",
        page: this.page.page,
        pageSize: this.page.pageSize,
      };
      apis.recordList(params).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          // res.data.list.map(item => {
          //   item.children = [];
          // });
          this.tableListTwo = res.data.list;
          this.tableListTwo.length > 0 &&
            this.tableListTwo.forEach((item) => {
              item.buTime = moment(item.buTime).format("YYYY-MM-DD HH:mm");
            });
        }
      });
    },
    // 获取所属地点
    getSelectList() {
      apis.stockList().then((res) => {
        if (res.code == 200) {
          this.selectList = res.data;
        }
      });
    },
    // 分页变化
    currChange(value) {
      this.page.page = value;
      if (this.tabIndex == 0) {
        this.getListOne();
      }
    },
    // 提交
    onSubmit() {
      console.log("submit!");
      this.page.page = 1;
      if (this.tabIndex == 0) {
        this.getListOne();
      } else {
        this.getListTwo();
      }
    },
    // 重置
    onReset() {
      this.page.page = 1;
      this.$refs.formInline.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.fullBox {
  width: 100%;
  height: 100%;
  font-size: 11px * $zoom;
  position: relative;
  overflow: hidden;
  padding: 0 0 40px;
  background: #fff;
  border-radius: 40px;
  .mobile {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: #f0f2f5;
    display: flex;
    justify-content: center;
    font-size: 11px * $zoom;
    @media screen and (max-width: 600px) {
      .mobile_full {
        width: 100%;
        background: url("~@/assets/newMedal/bg2.png");
        background-size: 100% 100%;
      }
    }
    @media screen and (min-width: 600px) {
      .mobile_full {
        width: 276px * $zoom;
        background: url("~@/assets/newMedal/bg2.png");
        background-size: 100% 100%;
      }
    }
  }
  .tabBox {
    padding: 0 40px;
    height: 140px;
    border-bottom: 1px solid #eeeff2;
    display: flex;
    align-items: center;
    .tab_item {
      width: 180px;
      height: 100%;
      margin-right: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
    }
    .active {
      color: #4fa27d;
      border-bottom: 4px solid #4fa27d;
      font-weight: bold;
      margin-bottom: -4px;
    }
  }
  .content {
    .unifiedForm {
      border-bottom: 1px solid #eeeff2;
      padding: 40px 40px 0;
      .label {
        font-size: 11px * $zoom;
        margin-bottom: 20px;
      }
      ::v-deep {
        .el-form {
          display: flex;
          align-items: flex-end;
        }
        .el-form-item {
          margin-right: 40px;
        }
        .el-input,
        .el-date-editor {
          width: 13vw;
          height: 35px * $zoom;
          background: #fafafa;
          border-radius: 20px;
          .el-input__inner {
            width: 13vw;
            height: 35px * $zoom !important;
            background: #fafafa;
            // border: 1px solid #ccc;
            border-radius: 20px;
          }
          .el-range-separator {
            line-height: 33px * $zoom !important;
            padding: 0 40px 0 20px;
          }
          .el-range-input {
            background: #fafafa !important;
          }
        }
        .el-button {
          width: 64px * $zoom;
          height: 35px * $zoom;
          background: #4fa27d;
          border-radius: 20px;
          font-size: 11px * $zoom;
          color: #fff;
          span {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          i {
            font-size: 13px * $zoom;
            margin-right: 10px;
          }
        }
        .reset {
          background: #fafafa;
          color: #666666;
          border: 1px solid #fafafa;
        }
      }
    }
    .tableBox {
      padding: 40px 40px 0;
      ::v-deep {
        thead {
          tr {
            th {
              background: #fafafa;
              height: 100px;
            }
          }
        }
        tbody {
          tr {
            td {
              background: #fff;
              height: 140px;
              .cell {
                // display: flex;
                // align-items: center;
                // justify-content: center;
              }
            }
          }
          .tag {
            max-width: 120px;
            padding: 10px 10px;
            border-radius: 10px;
          }
          .tag1 {
            color: #fe964a;
            background: #fff0e6;
          }
          .tag2 {
            color: #0caf60;
            background: #e7f7ef;
          }
          .tag3 {
            color: #fd6a6a;
            background: #fff0f0;
          }
        }
        .el-table--mini .el-table__cell {
          padding: 0 !important;
        }
      }
    }
    .pager {
      margin: 30px 30px 0 0;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
